/**
 * article-content-cleanup.js
 *
 * Blog posts are often pasted from word processors (TinyMCE leaves
 * data-mce-* attributes, span soup, and — worst for layout — whitespace/nbsp
 * "spacer" paragraphs like <p>&nbsp;</p>). The spans are visually harmless,
 * but the spacer paragraphs wreck the vertical rhythm the stylesheet sets.
 *
 * This removes paragraphs whose text content is only whitespace (including
 * non-breaking spaces) from the article body. Content-editing in Shopify
 * admin is untouched — this is render-time hygiene only.
 */

(function () {
  'use strict';

  function isBlank(el) {
    if (el.querySelector('img, iframe, video, embed')) return false;
    return (el.textContent || '').replace(/[\s\u00A0]/g, '') === '';
  }

  // Paste pattern: hand-typed bullet lines ("<p>\u2022\ttext</p>", Apple Notes
  // tab-spans included) \u2014 promote consecutive runs into a real <ul> so they
  // render as an actual list.
  function promoteManualBullets(body) {
    var paras = Array.prototype.slice.call(body.querySelectorAll('p'));
    var list = null;
    paras.forEach(function (p) {
      var text = (p.textContent || '').replace(/^[\s\u00A0]+/, '');
      if (text.charAt(0) === '\u2022') {
        if (!list || p.previousElementSibling !== list) {
          list = document.createElement('ul');
          p.parentNode.insertBefore(list, p);
        }
        var li = document.createElement('li');
        li.innerHTML = p.innerHTML;
        list.appendChild(li);
        p.remove();
        // Strip the literal bullet character from the promoted item.
        var walker = document.createTreeWalker(li, NodeFilter.SHOW_TEXT);
        var node;
        var stripped = false;
        while (!stripped && (node = walker.nextNode())) {
          var idx = node.nodeValue.indexOf('\u2022');
          if (idx !== -1) {
            node.nodeValue = node.nodeValue.slice(idx + 1);
            stripped = true;
          }
        }
      } else {
        list = null;
      }
    });
  }

  function clean() {
    var bodies = document.querySelectorAll('.article-template__content');
    bodies.forEach(function (body) {
      // Whitespace-only paragraphs, headings, and list items \u2014 paste spacers
      // that wreck rhythm (and empty headings would render orphan gold rules).
      body.querySelectorAll('p, h1, h2, h3, h4, h5, h6, li').forEach(function (el) {
        if (isBlank(el)) el.remove();
      });
      promoteManualBullets(body);
      // Lists emptied by the removals above.
      body.querySelectorAll('ul, ol').forEach(function (el) {
        if (!el.children.length) el.remove();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clean);
  } else {
    clean();
  }
})();
